import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const destinationMarketsSchema: CollectionCreateSchema = {
  name: CollectionName.DestinationMarkets,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
